import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rdf-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.css']
})
export class NumberInputComponent implements OnInit {
  @Input() field
  constructor() { }

  ngOnInit() {
  }

}
